import i18next from 'i18next';
import { DashboardLang } from '../../../../constants/DashboardLang';

export const getLangLabel = (languageCode: DashboardLang): string => {
    const mapLanguageCodeToLabel: Map<DashboardLang, string> = new Map<DashboardLang, string>([
        [DashboardLang.English, i18next.t('default.activation_email_modal.lang_selector.english')],
        [DashboardLang.Spanish, i18next.t('default.activation_email_modal.lang_selector.spanish')],
        [DashboardLang.French, i18next.t('default.activation_email_modal.lang_selector.french')],
        [DashboardLang.German, i18next.t('default.activation_email_modal.lang_selector.german')],
        [DashboardLang.Italian, i18next.t('default.activation_email_modal.lang_selector.italian')],
        [DashboardLang.Portuguese, i18next.t('default.activation_email_modal.lang_selector.portuguese')],
    ]);
    return mapLanguageCodeToLabel.get(languageCode) || languageCode.valueOf();
};
